import { OAuthProvider } from "firebase/auth";

export const CHECK2_USERS_COLLECTION = "AML Checks";
export const AUTH_NOT_READY = "__NOT_READY__";

export const CHECK2_ROLES = {
  SUPERADMIN: "superadmin",
  ADMIN: "admin",
  USER: "user",
};

export const normalizeEmail = (email) =>
  String(email || "")
    .toLowerCase()
    .trim();

export const normalizeRole = (role) => {
  const cleanRole = String(role || CHECK2_ROLES.USER)
    .toLowerCase()
    .trim();

  if (Object.values(CHECK2_ROLES).includes(cleanRole)) {
    return cleanRole;
  }

  return CHECK2_ROLES.USER;
};

export const normalizeEmailList = (emails) => {
  if (!Array.isArray(emails)) return [];

  return emails.map((email) => normalizeEmail(email)).filter(Boolean);
};

export const getAuthenticatedEmail = (user = {}) => {
  const directEmail = String(user?.email || "").trim();

  if (directEmail) {
    return directEmail;
  }

  const providerEmail =
    user?.providerData
      ?.map((provider) => String(provider?.email || "").trim())
      ?.find(Boolean) || "";

  if (providerEmail) {
    return providerEmail;
  }

  const reloadUserInfoEmail = String(user?.reloadUserInfo?.email || "").trim();

  if (reloadUserInfoEmail) {
    return reloadUserInfoEmail;
  }

  return "";
};

export const createMicrosoftProvider = () => {
  const microsoftProvider = new OAuthProvider("microsoft.com");

  microsoftProvider.setCustomParameters({
    prompt: "select_account",
  });

  return microsoftProvider;
};

export const buildCheck2UserAuthRecord = (documentSnapshot) => {
  const data = documentSnapshot.data() || {};

  const email = normalizeEmail(data.email || documentSnapshot.id);

  if (!email) return null;

  return {
    email,
    role: normalizeRole(data.role),
    adminEmail: normalizeEmail(data.adminEmail),
    users: normalizeEmailList(data.users),
    company: String(data.company || "").trim(),
    active: data.active !== false,
  };
};

export const buildCheck2UsersMap = (snapshot) => {
  const usersMap = new Map();

  snapshot.forEach((documentSnapshot) => {
    const userRecord = buildCheck2UserAuthRecord(documentSnapshot);

    if (!userRecord || !userRecord.active) return;

    usersMap.set(userRecord.email, userRecord);
  });

  return usersMap;
};
